var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.replies),function(reply){return _c('BaseReply',{key:reply.id,attrs:{"data":reply},on:{"click-up":function($event){_vm.replyUp(reply.id)}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }